<script setup>
import { entries, formatDay, get, loadEpsgs, post, validators } from '@/common/util'
import ConfirmCard from '@/components/ConfirmCard.vue'
import { useMetaStore } from '@/stores'
import _ from 'lodash-es'
import { reactive } from 'vue'
const metaStore=useMetaStore()
const meta=reactive({details:[{tk:'maptypes',col:'bmtype',val:'directinput',items:['vworld - Base','vworld - white','vworld - midnight','vworld - Hybrid','vworld - Satellite','OSM','NAVER','KAKAO','GOOGLE - Satellite','GOOGLE - Base','directinput']}
  ,{tk:'mapname',col:'nm',mandatory:true},{tk:'apikey',col:'apikey'},{tk:'url',col:'url',mandatory:true},{tk:'epsg',col:'epsg',val:4326},{tk:'extension',col:'ext',val:'png',items:['png','jpg','jpeg','gif','webp','none']}]
  ,headers:[{tk:'defaultmapornot',col:'initial',switch:true},{tk:'maptype',col:'bmtype'},{tk:'integrationstatus'},{tk:'enabled',col:'enabled',switch:true},{tk:'mapname',col:'nm'},{tk:'apikey',col:'apikey'},{tk:'dateofmod',col:'mdt'}]
  ,vwurl:'https://api.vworld.kr/req/tms/1.0.0/{apikey}/{type}/{z}/{x}/{y}.{ext}'})
,pop=(type,row)=>{
  meta.selrow=row
  if(row)meta.details.forEach(de=>de.val=row[de.col])
  if(_.isEmpty(type)||type.toString().includes('Event'))return metaStore.pop({ison:false})
  if(type!='del')loadEpsgs(epsgs=>{
    meta.details.find(de=>de.col=='epsg').items=epsgs
  })
  meta.poptype=null
  metaStore.pop({ison:true,callback:() =>meta.poptype=type})
},save=()=>{
  const pd={}
  meta.details.forEach(de=>pd[de.col]=de.val)
  if(meta.selrow){
    pd.id=meta.selrow.id
    pd.cdt=meta.selrow.cdt
  }
  if(pd.bmtype.toLowerCase().includes('naver')||pd.bmtype.toLowerCase().includes('kakao')||pd.bmtype.toLowerCase().includes('google'))pd.nm=pd.bmtype
  if(meta.rows.filter(row=>pd.id?pd.id!=row.id:true).some(item=>item.nm==pd.nm))return metaStore.toastKey('nm_already_taken',false)
  if(pd.bmtype.toLowerCase().includes('naver')&&!meta.navermapkey)return metaStore.toast('NAVER 지도 API 키를 등록해주세요.',false)
  if(pd.bmtype.toLowerCase().includes('kakao')&&!meta.kakaomapkey)return metaStore.toast('KAKAO 지도 API 키를 등록해주세요.',false)
  metaStore.blockLoading()
  post('rest/authed/admin/putbasemap',pd,res=>{
    metaStore.blockLoading(false)
    metaStore.toastRslt(res,true)
    init()
  })
},typeChanged=val=>{
  const rslt={url:'',nm:'',epsg:'',ext:''}
  if(val.startsWith('vworld')){
    rslt.url=meta.vwurl
    rslt.nm=val
    rslt.ext=val.endsWith('Satellite')?'jpeg':'png'
    rslt.epsg=3857
  }else if(val=='OSM'){
    rslt.nm=val
  }
  entries(rslt).forEach(ent=>_.find(meta.details,{col:ent.key}).val=ent.value)
},isDirect=()=>{
  return meta.details.find(mde=>mde.col=='bmtype').val=='directinput'
},del=async()=>{
  metaStore.blockLoading()
  const res=await post('rest/authed/admin/delbasemap',meta.selrow)
  metaStore.toastRslt(res)
  metaStore.blockLoading(false)
  init()
},saveToggle=async(sel)=>{
  if(sel.col=='initial'&&sel.val)meta.rows.filter(row=>row.id!=sel.id).forEach(row=>row.initial=false)
  metaStore.blockLoading()
  const res=await post('rest/authed/admin/basemapenablesinitial',meta.rows.map(row=>({id:row.id,enabled:row.enabled,initial:row.initial})))
  metaStore.toastRslt(res,true)
  metaStore.blockLoading(false)
  init()
},init=async()=>{
  metaStore.blockLoading()
  meta.rows=await get('rest/authed/member/basemaps')
  meta.rows=meta.rows.data
  const naverandkakaokeys=['navermapkey','kakaomapkey'];
  naverandkakaokeys.forEach(key=>get('rest/authed/member/confs/'+key,res=>{
    if(res.data.length)meta[key]=res.data[0].sval
  }))
  metaStore.blockLoading(false)
}
meta.details.find(de=>de.col=='bmtype').items=meta.details.find(de=>de.col=='bmtype').items.map(mt=>({key:mt,val:mt}))
init()
defineExpose({init})
</script>
<template>
  <v-card flat class="manbgmap">
    <v-card-title>
      <v-row no-gutters>
        <v-col class="text-subtitle-1">
          <v-breadcrumbs :items="[$t('maptypes'),$t('backgroundmap')]"/>
        </v-col>
        <v-col class="text-end">
          <v-btn class="me-5" @click="init">{{ $t('refresh') }}</v-btn>
          <v-btn color="primary" @click="pop('new')">{{ $t('newregistration') }}</v-btn>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-table v-if="meta.rows">
        <thead>
          <tr>
            <th class="text-center" v-for="head in meta.headers">{{ $t(head.tk) }}</th>
            <th class="text-center">{{ $t('viewdetails') }}</th>
            <th class="text-center">{{ $t('delete') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in meta.rows">
            <td v-for="head in meta.headers" class="text-center">
              <div v-if="head.tk=='integrationstatus'">{{$t('normal')}}</div>
              <div v-else-if="head.switch">
                <v-switch hide-details color="primary" class="center" v-model="row[head.col]" @update:model-value="val=>saveToggle({...head,val:val,id:row.id})"/>
              </div>
              <div v-else-if="head.col=='mdt'">{{ formatDay(row[head.col]) }}</div>
              <div v-else>{{ head.col=='bmtype'&&row[head.col]=='directinput'?$t('directinput'):row[head.col] }}</div>
            </td>
            <td class="text-center"><v-btn :text="$t('viewdetails')" @click="pop('detail',row)"/></td>
            <td class="text-center"><v-btn color="error" :text="$t('delete')" @click="pop('del',row)"/></td>
          </tr>
        </tbody>
      </v-table>
    </v-card-text>
  </v-card>
  <Teleport v-if="meta.poptype" to="#popbody">
    <v-card v-if="meta.poptype=='new'||meta.poptype=='detail'" width="450">
      <v-card-title>
        <v-row>
          <v-col cols="10">{{ $t('registermaps') }}/{{ $t('viewdetails') }}</v-col>
          <v-spacer/>
          <v-col class="text-end"><v-icon icon="mdi-close" class="cursor-pointer" @click="pop"/></v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row no-gutters v-for="de in meta.details" class="mb-2">
          <v-col>
            <v-select v-if="de.col=='bmtype'" hide-details variant="outlined" density="compact" :items="de.items" :label="$t(de.tk)" v-model="de.val" :item-title="item=>item.key=='directinput'?$t(item.val):item.val" item-value="val"
              @update:model-value="typeChanged"/>
            <v-combobox v-else-if="de.col=='epsg'" hide-details variant="outlined" density="compact" :disabled="!isDirect()" :label="$t(de.tk)" :items="de.items" v-model="de.val"/>
            <v-select v-else-if="de.col=='ext'" hide-details variant="outlined" density="compact" :disabled="!isDirect()" :label="$t(de.tk)" :items="de.items" v-model="de.val"/>
            <v-text-field v-else variant="outlined" density="compact" :disabled="!isDirect()" :hide-details="!de.mandatory" :label="$t(de.tk)+(de.mandatory?' *':'')"
              :rules="[de.mandatory?validators.required:true,de.col=='url'?validators.isValidUrl:true]" :placeholder="$t('plzent_lbl_').replace('_lbl_',$t(de.tk))" v-model="de.val"/>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-row justify="end">
          <v-btn :text="$t('cancel')" variant="outlined" @click.stop="pop"/>
          <v-btn :text="$t('confirm')" class="ms-2 me-3" variant="elevated" color="primary" @click="save"
            :disabled="!meta.details.filter(de=>de.mandatory).every(de=>validators.required(de.val)===true)&&validators.isValidUrl(meta.details.find(de=>de.col=='url').val)===true"/>
        </v-row>
      </v-card-actions>
    </v-card>
    <ConfirmCard v-if="meta.poptype=='del'" :ttl="$t('del_lbl_conttl').replace('_lbl_',$t('backgroundmap'))" @cancel="pop" @confirm="del"/>
  </Teleport>
</template>
